<template>
  <md-input
    v-model="priceLocal"
    @blur.native="format"
  ></md-input>
</template>

<script>
export default {
  name: 'currency-input',
  data () {
    return {
      priceLocal: undefined
    }
  },
  created () {
    this.priceLocal = this.price
    this.format()
  },
  props: ['price'],
  methods: {
    format () {
      this.priceLocal = parseFloat(this.priceLocal) || 0
      this.priceLocal = this.priceLocal.toFixed(2)
      this.$emit('priceChanged', this.priceLocal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/CurrencyInput.vue